import React from 'react'
import PropTypes from 'prop-types'
import SelectInput from '../../inputs/select-input'
import DateSelect from '../../inputs/date-select'
import Checklist from '../../inputs/checklist'

const ScheduleSettings = props => {
  const { wdays, setWdays, hidden, register, control, errors, setValue, getValues } = props
  const durationOptions = [['', 'Select'], [60, '1.0 hr'], [90, '1.5 hrs'], [120, '2.0 hrs']]
  const timesOptions = [
    ['', 'Select'], ['6', '6 AM'], ['7', '7 AM'], ['8', '8 AM'], ['9', '9 AM'], ['10', '10 AM'], 
    ['11', '11 AM'], ['12', '12 PM'], ['13', '1 PM'], ['14', '2 PM'], ['15', '3 PM'], ['16', '4 PM'], 
    ['17', '5 PM'], ['18', '6 PM'], ['19', '7 PM'], ['20', '8 PM'], ['21', '9 PM'], ['22', '10 PM'], ['23', '11 PM']
  ]
  const requiredMsg = 'Is required'

  const days = [
    {id: 1, name: 'Mon'},
    {id: 2, name: 'Tue'},
    {id: 3, name: 'Wed'},
    {id: 4, name: 'Thu'},
    {id: 5, name: 'Fri'},
    {id: 6, name: 'Sat'},
    {id: 7, name: 'Sun'},
  ]

  const greaterThanFrom = (value) => {
    const from = getValues('start_time')
    if (parseInt(from) >= parseInt(value)) return 'Must be > From'
    return true
  }

  return <div className='step-section' hidden={hidden}>
    <div className='row'>
      <div className='col-xs-12 col-sm-10'>
        <div className='section-title'>Schedule Info</div>
      </div>
    </div>

    <div className='row'>
      <div className='col-xs-12 col-sm-5'>
        <DateSelect name='start_date' control={control} label='Start date' />
      </div>
    </div>

    <div className='row'>
      <div className='col-xs-12 col-sm-5'>
        <SelectInput
          {...register('duration', { required: requiredMsg })}
          options={durationOptions}
          label='Game duration'
          error={errors.duration}
          onChange={(e) => setValue('duration', e.target.value)}
        />
      </div>
    </div>

    <div className='row'>
      <div className='col-xs-12'>
        <Checklist
          control={control}
          name='days'
          options={days}
          selected={wdays}
          error={errors.days}
          onChange={setWdays}
          label='Days of the week when the league is played'
        />
      </div>
    </div>

    <div className='row'>
      <div className='col-xs-12'>
        <label className='league-label'>Time range for the league games</label>
      </div>
      <div className='col-xs-12 col-sm-6 col-md-4'>
        <SelectInput
          {...register('start_time', { required: requiredMsg })}
          label='From'
          options={timesOptions}
          error={errors.start_time}
          onChange={e => setValue('start_time', e.target.value)}
        />
      </div>
      <div className='col-xs-12 col-sm-6 col-md-4'>
        <SelectInput
          {...register('end_time', { required: requiredMsg, validate: greaterThanFrom })}
          label='To'
          options={timesOptions}
          error={errors.end_time}
          onChange={e => setValue('end_time', e.target.value)}
        />
      </div>
    </div>

    <div className='button-section'>
      <button className='team-button next-button' type='submit'>
        {props.schedule ? 'Update Schedule' : 'Create Schedule'}
      </button>
    </div>
  </div>
}

ScheduleSettings.propTypes = {
  schedule: PropTypes.object,
  hidden: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired
}

export default ScheduleSettings
